import { getDistance } from 'geolib'

/*
 * @param: coordinates, pass in current Latittude and current Longitude
 * @param: starting points: list of starting points to match
 * @param: defaultDasherStartingPointId: fallback incase GPS fails
 * @param: disableLocation: gps override and only fetch details
 *
 * this function will find the closest starting point to a given longitude and * lattidue.
 */
export const getDasherStartingPointDetails = (
  { currentLat, currentLng },
  startingPoints,
  defaultDasherStartingPointId,
  isLocationEnabled = true
) => {
  let sp = {
    distance: null,
  }
  let distance

  const isLocationDisabled = !isLocationEnabled || !currentLat || !currentLng
  if (!startingPoints) {
    return
  }
  for (const x in startingPoints) {
    if (startingPoints[x]) {
      const i = startingPoints[x]

      if (isLocationDisabled && i.id === defaultDasherStartingPointId) {
        // do not have current dasher location so defaulting to fetching value from
        // dasher object, we need this to get current status on the starting point
        // ie; busy levels
        return startingPoints[x]
      } else if (!isLocationDisabled) {
        const { lng, lat } = startingPoints[x].location
        const d = getDistance(
          { latitude: currentLat, longitude: currentLng },
          { latitude: lat, longitude: lng }
        )

        // Assign closest distance id and location status for default vehicle
        if (distance > d || distance == null) {
          distance = d
          sp = startingPoints[x]
        }
      }
    }
  }
  if (!sp) {
    // Returning earliest starting point if it somehow falls into this edge case
    sp = startingPoints[0]
  }

  sp.distance = distance

  return sp
}
